import React from "react";

export const BrandHeader = ({ creator, theme, themeName }) => {
  const logo = (creator.logo_url || "").trim();
  const business = creator.business_name || creator.name;
  const taxId = (creator.tax_id || "").trim();

  if (logo) {
    return (
      <div className="flex flex-col gap-2">
        <img src={logo} alt="Brand logo" className="h-10 w-auto max-w-[180px] object-contain" data-testid="brand-logo" />
        <div className={`${theme.body} text-sm font-medium`}>{business}</div>
        {taxId && <div className={`${theme.muted} text-xs tracking-wide`}>Tax ID · {taxId}</div>}
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-1">
      <div className={`${theme.body} text-base ${themeName === "modernist" ? "font-black uppercase tracking-tight" : "font-semibold"}`}>
        {business}
      </div>
      <div className={`${theme.muted} text-xs`}>Issued via Quill</div>
      {taxId && <div className={`${theme.muted} text-xs tracking-wide mt-1`}>Tax ID · {taxId}</div>}
    </div>
  );
};
